import { useContext } from 'react';

import { AppContext } from '../context/app';
import type { Place } from '../context/types';
import { ensureHttps } from '../utils/url';
import useIsMobile from './useIsMobile';

export const useSetPlace = () => {
  const {
    selectedSite,
    setSelectedBuilding,
    setSelectedFloor,
    setMap,
    setSelectedLocation,
    setShowKeyboard,
  } = useContext(AppContext);
  const isMobile = useIsMobile();

  return (place: Place | undefined) => {
    // TODO use when exiting navigation on kiosk
    if (!place) return;
    const building = selectedSite?.buildings.find(
      (b) => b.id === place.location.building,
    );
    setSelectedBuilding(building);
    const floor = building?.floors
      .sort((a, b) => a.id - b.id)
      .find((b) => place.location.floor === b.id);
    setSelectedFloor(floor);
    floor && setMap(ensureHttps(floor.map_url));

    setSelectedLocation(place);
    setShowKeyboard(false);
    if (isMobile) {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth',
      });
    }
  };
};
